
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Header from './header.vue';
import { Tnc } from '@tencent/wphk-act-base-ui';
import ActivityDesc from './activity-desc.vue';
import { ActivityDescInfo, TncInfo, HeaderInfo, ActCycleInfo } from './types';
import ActCycleDialog from '../act-cycle-dialog/act-cycle-dialog.vue';

@Component({
  name: 'BankAct',
  components: {
    Header,
    ActivityDesc,
    Tnc,
    ActCycleDialog,
  },
})
export default class BankAct extends Vue {
  /** 主题色 */
  @Prop({ default: '#fff' }) theme?: string;
  /** 头部信息 */
  @Prop() headerInfo?: HeaderInfo;
  /** 活动说明信息 */
  @Prop() activityDescInfo?: ActivityDescInfo;
  /** tnc信息 */
  @Prop() tncInfo?: TncInfo;
  /** 活动周期信息 */
  @Prop() actCycleInfo?: ActCycleInfo;
  // biExt
  fbusiness = localStorage.getItem('fbusiness');

  /** 整体样式 */
  public get bankActStyle() {
    return {
      background: this.theme,
    };
  }

  /** 内容样式 */
  public get bankActConentStyle() {
    return {
      paddingTop: `${(this.headerInfo?.headerHeight || 320) / 200}rem`,
    };
  }

  public get tncColor() {
    return this.activityDescInfo?.color || '#ffffff';
  }

  @Emit('toTnc')
  public toTnc() {}
}
